import styled, { keyframes } from 'styled-components';

const rise = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PopupWrap = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  width: min(380px, calc(100vw - 32px));
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamily};
  background: ${({ theme }) => theme.colors.card};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadowCardHover};
  animation: ${rise} 0.35s ease-out;
`;

export const PopupImageWrap = styled.div`
  position: relative;
`;

export const PopupImage = styled.img`
  width: 100%;
  height: 140px;
  object-fit: cover;
  display: block;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 12px);
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
`;

export const SponsoredTag = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0.2rem 0.55rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 14px);
  background: ${({ theme }) => theme.colors.crimson};
  color: ${({ theme }) => theme.colors.crimsonForeground};
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const PopupBody = styled.div`
  padding: 1.2rem 1.25rem 1.35rem;
`;

export const PopupTitle = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.lg};
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.foreground};
`;

export const PopupDesc = styled.p`
  margin: 0.5rem 0 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  line-height: 1.55;
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

export const PopupActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.1rem;
  flex-wrap: wrap;
`;

export const CtaButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 1.1rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 8px);
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
  text-decoration: none;

  &:hover {
    opacity: 0.92;
  }
`;

export const GhostBtn = styled.button`
  background: none;
  border: none;
  padding: 0.5rem 0.35rem;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.mutedForeground};
  cursor: pointer;
  font-family: inherit;

  &:hover {
    color: ${({ theme }) => theme.colors.foreground};
  }
`;
